import styled from 'styled-components';

export const Div = styled.div`
    width: calc(100% - 290px);
    height: calc(100vh - 50px);
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
  z-index: 1;
  padding: 0 20px 20px;
`;
